var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotificationsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Bell, Notification",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9345",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7489",
    d: "M9.708 18.344v.365A2.292 2.292 0 0012 21h0a2.292 2.292 0 002.292-2.292v-.365"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7490",
    d: "M13.833 5.751v-.918A1.833 1.833 0 0012 3h0a1.833 1.833 0 00-1.833 1.833v.918"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7491",
    d: "M6.563 10.188h0a4.531 4.531 0 014.531-4.531h1.813a4.531 4.531 0 014.531 4.531h0v2.8a2 2 0 00.586 1.414l.641.641a2 2 0 01.586 1.414h0a1.89 1.89 0 01-1.89 1.89H6.64a1.89 1.89 0 01-1.89-1.89h0a2 2 0 01.586-1.414l.641-.641a2 2 0 00.586-1.414v-2.8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 7492",
    d: "M0 0h24v24H0z",
    fill: "none"
  })));
}

export default SvgNotificationsIcon;


//////////////////
// WEBPACK FOOTER
// ./src/icons/NotificationsIcon.svg
// module id = 851
// module chunks = 101